export default "__VITE_ASSET__16f91b21__"